import {Dispatch} from 'redux';
import {DATETABS_SET_TABS, SPORTFILTER_SET_FILTER} from 'store/actionTypes';
import {DateTab, SportFilter} from 'utils/types';
import {SportFilterSetAction} from '../types';

// TODO: documentation

const setSportFilter = (filter: SportFilter) => (
  dispatch: Dispatch<SportFilterSetAction>
): void => {
  dispatch({
    type: SPORTFILTER_SET_FILTER,
    payload: {filter},
  });
};

export default setSportFilter;
